import { useState } from 'react';
import { updates } from '../data';
import SectionHeader from './SectionHeader';

export default function Updates() {
  const [openId, setOpenId] = useState<string | null>('u-1');
  const excerptMap: Record<string, string> = {
    'u-1': '制作方同步释出概念海报与完整演员名单，多位实力派与新生代同框，被网友看作本季最值得期待的卡司组合，选角与题材方向成为评论区热议焦点。',
    'u-2': '双方确认将以更灵活的共创模式展开合作，内容品类也将从短视频延伸到直播与线下活动，消息公布后相关账号关注度明显走高。',
    'u-3': '首批名单涵盖流行、民谣与乐队等多风格音乐人，组委会表示后续还将分批揭晓，乐迷已开始围绕演出时段与阵容组合展开讨论。',
    'u-4': '决胜局逆风翻盘的高光时刻刷屏，冠军战队官宣将代表赛区出征全球赛，教练组赛后的战术复盘也被整理成经典教材流传。',
    'u-5': '本次联名以限定材质与复古配色为主打，线上线下同步首发，预约数据刷新品牌历史纪录，周边也一度出现供不应求的讨论。',
    'u-6': '节目组透露推理设定将引入全新世界观，嘉宾阵容涵盖演员与综艺熟脸，首期录制花絮曝光后，观众对赛制细节的猜测不断。',
  };

  return (
    <section id="update" className="scroll-mt-20 border-y border-background-200/70 bg-background-100/60 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_360px]">
          <div>
            <SectionHeader
              kicker="Latest Updates"
              title="最新收录动态"
              desc="最近收录与更新的吃瓜话题列表。点击任意一条可展开查看摘要脉络。"
            />
            <div className="space-y-3">
              {updates.map((u) => {
                const isOpen = openId === u.id;
                return (
                  <article
                    key={u.id}
                    className="overflow-hidden rounded-2xl border border-background-200/80 bg-background-50 transition hover:border-primary-200"
                  >
                    <button
                      type="button"
                      onClick={() => setOpenId(isOpen ? null : u.id)}
                      className="flex w-full items-center gap-4 px-4 py-4 text-left md:px-5"
                      aria-expanded={isOpen}
                    >
                      <span className="hidden h-2.5 w-2.5 shrink-0 rounded-full bg-primary-500 sm:block" aria-hidden="true"></span>
                      <span className="min-w-0 flex-1">
                        <span className="block truncate text-[15px] font-medium text-foreground-900">{u.title}</span>
                      </span>
                      <span className="hidden shrink-0 items-center gap-1.5 rounded-full bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-800 md:inline-flex">
                        {u.cat}
                      </span>
                      <span className="shrink-0 text-xs text-foreground-400">{u.time}</span>
                      <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-foreground-400 transition ${isOpen ? 'bg-primary-100 text-primary-700' : 'bg-background-200/80'}`}>
                        <i className={isOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} aria-hidden="true"></i>
                      </span>
                    </button>
                    {isOpen ? (
                      <div className="border-t border-background-200/70 bg-background-100/40 px-4 pb-4 pt-3 md:px-5">
                        <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-400">
                          <span>分类：{u.cat}</span>
                          <span>·</span>
                          <span>阅读 {u.read}</span>
                        </div>
                        <p className="mt-2 text-sm leading-relaxed text-foreground-600">{excerptMap[u.id]}</p>
                      </div>
                    ) : null}
                  </article>
                );
              })}
            </div>
          </div>

          <aside className="lg:pt-24">
            <div className="rounded-3xl bg-accent-500 p-6 text-background-50">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-background-50/20 text-xl">
                <i className="ri-notification-3-line" aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-xl font-bold">不知道从哪里开始吃瓜？</h3>
              <p className="mt-2 text-sm leading-relaxed text-background-50/90">
                先从“今日热榜”看大家都在追什么，再顺着“分类导航”进入你感兴趣的板块。常设栏目适合长期关注，精品专题则能一次补全一段完整脉络。
              </p>
              <a
                href="#hot"
                onClick={() => document.getElementById('hot')?.scrollIntoView({ behavior: 'smooth' })}
                className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-5 py-2.5 text-sm font-semibold text-accent-700 transition hover:bg-background-100"
              >
                去热榜逛逛 <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </div>
            <div className="mt-4 rounded-3xl border border-background-200/80 bg-background-50 p-6">
              <p className="text-sm font-semibold text-foreground-800">内容导航小贴士</p>
              <ul className="mt-3 space-y-2.5 text-sm text-foreground-500">
                <li className="flex gap-2"><i className="ri-checkbox-circle-line mt-0.5 text-accent-600" aria-hidden="true"></i>热榜·看热度，分类·找方向</li>
                <li className="flex gap-2"><i className="ri-checkbox-circle-line mt-0.5 text-primary-600" aria-hidden="true"></i>专题·补脉络，栏目·追更新</li>
                <li className="flex gap-2"><i className="ri-checkbox-circle-line mt-0.5 text-secondary-600" aria-hidden="true"></i>标签·筛特征，搜索·直达内容</li>
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}